<template>
	<div class="center">
		<h1 class="sz-6 text-center">
			<a v-if="backButton" class="align--no-descenders" @click="$router.go(-1)">
				<Inline svg="chevron-left" class="sz-3 text-icon-subtle" />
			</a>
			{{ title }}
		</h1>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	export default defineComponent({
		name: 'AuthPageHeader',
		props: {
			title: { type: String, default: '' },
			backButton: { type: Boolean, default: false }
		}
	});
</script>